// Canonical production URL for the live site.
// Used for:
//   - JSON-LD structured data (must be canonical for SEO across all environments)
//   - Copy-share buttons (we always want donors to receive the live URL,
//     not the preview URL the team happens to be testing on)
export const SITE_URL = "https://storiesbyaradhana.com";

// Helper to build a fully-qualified public URL from a relative path.
export function siteUrl(path = "") {
  if (!path) return SITE_URL;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}
